export enum KeyCode {
  ENTER = 13,
  ESC = 27,
}

export const stopPropagation = (event: React.SyntheticEvent) => event.stopPropagation();
